import {Component, OnInit, ViewChild} from '@angular/core';
import {MItemService} from '../../service/m-item/service/m-item.service';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {TStockLedgerService} from '../../service/t-stock-ledger/service/t-stock-ledger.service';
import {SnotifyService} from 'ng-snotify';
import {MItem} from '../../service/m-item/model/m-item';
import {Observable} from '../../../../../node_modules/rxjs';
import {TStockTransfer} from './model/t-stock-transfer';
import {TStockTransferItem} from './model/t-stocktransfer-item';
import {TStockTransferOutService} from './service/t-stock-transfer-out.service';
import {MBranch} from '../../service/m-branch/model/m-branch';
import {MStore} from '../../master-files/m-store/model/m-store';
import {MBranchService} from '../../service/m-branch/service/m-branch.service';
import {MStoreService} from '../../master-files/m-store/service/m-store.service';
import {AppSettings} from '../../settings/app-settings';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-t-stock-transfer-out',
  templateUrl: './t-stock-transfer-out.component.html',
})
export class TStockTransferOutComponent implements OnInit {

  private tStockTransfer: TStockTransfer;
  private tStockTransferItem: TStockTransferItem;
  private mItems: MItem [] = [];
  private mBranchs: MBranch [] = [];
  private fromMStores: MStore [] = [];
  private toMStores: MStore [] = [];
  private uiMode: string;
  private totalValues = new Map();

  @ViewChild('inputFormTGrn') inputFormTGrn;
  @ViewChild('inputFormGrnItem') inputFormGrnItem;

  constructor(private snotifyService: SnotifyService,
              private spinner: NgxSpinnerService,
              private tStockTransferOutService: TStockTransferOutService,
              private mStoreService: MStoreService,
              private mItemService: MItemService,
              private tStockLedgerService: TStockLedgerService,
              private mBranchService: MBranchService) {
    this.tStockTransfer = new TStockTransfer();
    this.tStockTransferItem = new TStockTransferItem();
  }

  ngOnInit() {
    this.spinner.show();
    this.uiMode = 'IDEAL';
    // this.loadMItems();
    this.loadMBranch();
    this.tStockTransfer = new TStockTransfer();
    this.tStockTransferItem = new TStockTransferItem();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

  findByTransactionNumber(): void {
    if (typeof this.tStockTransfer.transactionNumber !== undefined) {
      if (!this.tStockTransfer.transactionNumber) {
        this.snotifyService.error('Please Enter Trasaction Number', 'ERROR', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
        this.tStockTransfer = new TStockTransfer();
      } else {
        this.tStockTransferOutService.findByTransactionNumber(this.tStockTransfer.transactionNumber).subscribe((data) => {
            this.uiMode = 'SELECTED';
            this.tStockTransfer = data;
            this.tStockTransfer.transactionDate = new Date(this.tStockTransfer.transactionDate).toISOString().slice(0, 16);
            this.getTotal();
          },
          (e) => {
            this.snotifyService.error(e.error.message, 'ERROR', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            });
            this.tStockTransfer = new TStockTransfer();
          });
      }
    }
  }

  newFormData(): void {
    this.tStockTransfer.transactionNumber = null;
    this.uiMode = 'EDIT';
    this.tStockTransfer.transactionDate = new Date().toISOString().slice(0, 16);
  }

  sumbmitFormData(): void {
    if ('BRANCH_STOCK_TRANSFER' === this.tStockTransfer.transactionType) {
      if (!this.tStockTransfer.fromBranch) {
        this.snotifyService.warning('Select From Branch', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tStockTransfer.toBranch) {
        this.snotifyService.warning('Select To Branch', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tStockTransfer.transactionType) {
        this.snotifyService.warning('Select Transaction Type', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tStockTransfer.toBranch === this.tStockTransfer.fromBranch) {
        this.snotifyService.warning('From Branch And To Branch Same', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tStockTransfer.tStockTransferItemList.length === 0) {
        this.snotifyService.warning('Select Items And Qty', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tStockTransfer.tStockTransferItemList.length > 0 && this.tStockTransfer.toBranch && this.tStockTransfer.fromBranch && this.tStockTransfer.toBranch !== this.tStockTransfer.fromBranch) {
        this.tStockTransferSave();
      }
    } else {
      if (!this.tStockTransfer.fromBranch) {
        this.snotifyService.warning('Select From Branch', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tStockTransfer.toBranch) {
        this.snotifyService.warning('Select To Branch', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tStockTransfer.fromStore) {
        this.snotifyService.warning('Select From Store', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tStockTransfer.toBranch) {
        this.snotifyService.warning('Select To Store', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tStockTransfer.toStore.indexNo === this.tStockTransfer.fromStore.indexNo) {
        this.snotifyService.warning('From Store And To Store Same', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tStockTransfer.tStockTransferItemList.length === 0) {
        this.snotifyService.warning('Select Items And Qty', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (
        this.tStockTransfer.tStockTransferItemList.length > 0
        && this.tStockTransfer.toBranch
        && this.tStockTransfer.fromBranch
        && this.tStockTransfer.fromStore
        && this.tStockTransfer.toStore
        && this.tStockTransfer.toStore.indexNo !== this.tStockTransfer.fromStore.indexNo) {
        this.tStockTransferSave();
      }
    }
  }

  tStockTransferSave(): void {
    this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      buttons: [
        {
          text: 'Yes', action: (toast) => {
            this.snotifyService.remove(toast.id);
            this.tStockTransferOutService.save(this.tStockTransfer).subscribe((data) => {
              this.snotifyService.success('Grn Save Success!', AppSettings.MESSAGE_SUCCESS, {
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              });
              this.clearFormData();
            }, (e) => {
              this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              });
            });
          }
        },
        {
          text: 'No', action: (toast) => {
            this.snotifyService.remove(toast.id);
          }, bold: true
        },
      ]
    });
  }

  clearFormData(): void {
    this.uiMode = 'IDEAL';
    // this.loadMSuppliers();
    // this.loadMItems();
    this.loadMBranch();
    this.tStockTransfer = new TStockTransfer();
    this.tStockTransferItem = new TStockTransferItem();
  }

  selectTransactionType(transactionType: string): void {
    if ('BRANCH_STOCK_TRANSFER' === transactionType) {
      this.tStockTransfer.fromBranch = new MBranch();
      this.tStockTransfer.toBranch = new MBranch();
      this.tStockTransfer.fromStore = new MStore();
      this.tStockTransfer.toStore = new MStore();
    } else {
      this.tStockTransfer.fromBranch = new MBranch();
      this.tStockTransfer.toBranch = new MBranch();
      this.tStockTransfer.fromStore = new MStore();
      this.tStockTransfer.toStore = new MStore();
    }
  }

  // formatterMItem = (x: { barcode: string }) => x.barcode;
  // searchMItem = (text$: Observable<string>) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     map(term => term === '' ? []
  //       : this.mItems.filter(v => v.barcode.toString().toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 30))
  //   );

  // loadMItems(): void {
  //   this.spinner.show();
  //   this.mItemService.findAll().subscribe((data) => {
  //     this.mItems = data;
  //     if (this.mItems.length > 50000) {
  //       this.spinner.hide();
  //     }
  //   }, (e) => {
  //     this.mItems = [];
  //   });
  // }

  loadMBranch(): void {
    this.mBranchService.findByType('MAIN').subscribe((data) => {
      this.mBranchs = data;
      console.log(this.mBranchs);
    }, (e) => {
      this.mBranchs = [];
    });
  }

  loadFromMStore(fromBranch: MBranch): void {
    this.mStoreService.findByMBranch(fromBranch.indexNo).subscribe((data) => {
      this.fromMStores = data;
      if ('BRANCH_STOCK_TRANSFER' === this.tStockTransfer.transactionType) {
        for (var fromMStores of this.fromMStores) {
          if ('MAIN_STORE' === fromMStores.type) {
            this.tStockTransfer.fromStore = fromMStores;
            break;
          }
        }
      } else {
        this.tStockTransfer.toBranch = fromBranch;
        this.loadToMStore(this.tStockTransfer.toBranch);
      }
    }, (e) => {
      this.fromMStores = [];
    });
  }

  loadToMStore(toMBranch: MBranch): void {
    this.mStoreService.findByMBranch(toMBranch.indexNo).subscribe((data) => {
      this.toMStores = data;
      if ('BRANCH_STOCK_TRANSFER' === this.tStockTransfer.transactionType) {
        for (var toMStores of this.toMStores) {
          if ('MAIN_STORE' === toMStores.type) {
            this.tStockTransfer.toStore = toMStores;
            break;
          }
        }
      }
    }, (e) => {
      this.toMStores = [];
    });
  }

  itemFindByBarcode() {
    if (this.tStockTransferItem.itemBarcode) {
      this.mItemService.findByBarcode(this.tStockTransferItem.itemBarcode).subscribe((data) => {
        this.tStockTransferItem.item = data;
        this.tStockTransferItem.printDescription = this.tStockTransferItem.item.details;
        this.tStockLedgerService.getStockQtyByItemBarcodeAndBranchAndStore(this.tStockTransferItem.itemBarcode, this.tStockTransfer.fromBranch.indexNo, this.tStockTransfer.fromStore.indexNo).subscribe((data) => {
          this.tStockTransferItem.stock = data;
        }, (e) => {
          this.tStockTransferItem.stock = 0;
        });
      }, (e) => {
        this.snotifyService.warning('Item Not Found!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
        this.tStockTransferItem.item = new MItem();
      });
    }

  }

  getBalanceQty(): void {
    this.tStockTransferItem.balanceQty = this.tStockTransferItem.stock - this.tStockTransferItem.qty;
  }

  addTStockTransferItem(): void {
    if (!this.tStockTransferItem.item) {
      this.snotifyService.warning('Select Item Barcode', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (!this.tStockTransferItem.qty) {
      this.snotifyService.warning('Select Item Qty', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });

    } else if (!this.tStockTransfer.transactionType) {
      this.snotifyService.warning('Select Transaction Type', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (this.tStockTransferItem.stock < this.tStockTransferItem.qty) {
      this.snotifyService.warning('Enter valid Stock Transfer Qty', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (this.tStockTransferItem.item && this.tStockTransferItem.qty) {
      if (this.inputFormGrnItem.invalid) {
        this.snotifyService.warning('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else {
        this.tStockTransfer.tStockTransferItemList.unshift(this.tStockTransferItem);
        this.tStockTransferItem = new TStockTransferItem();
      }
    }
    this.getTotal();
  }

  editTStockTransferItem(rowNo, tStockTransferItem: TStockTransferItem): void {
    this.tStockTransferItem = tStockTransferItem;
    this.tStockTransfer.tStockTransferItemList.splice(rowNo, 1);
  }

  deleteTStockTransferItem(rowNo: number) {
    this.tStockTransfer.tStockTransferItemList.splice(rowNo, 1);
    this.getTotal();
  }

  getTotal(): void {
    this.totalValues = new Map();
    this.totalValues.set('totalRow', this.tStockTransfer.tStockTransferItemList.length);
    var totalItemQty: number = 0;
    var totalValue: number = 0;

    for (var tStockTransferItem of this.tStockTransfer.tStockTransferItemList) {
      totalItemQty += parseFloat(tStockTransferItem.qty.toString());
      totalValue += tStockTransferItem.item.price * tStockTransferItem.qty;
    }
    this.totalValues.set('totalItemQty', totalItemQty);
    this.totalValues.set('totalValue', totalValue);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-stock-transfer-out/t-stock-transfer-out.component.ts